import { render } from "./CloverPaymentSettingsModal.vue?vue&type=template&id=996c9114&scoped=true"
import script from "./CloverPaymentSettingsModal.vue?vue&type=script&lang=js"
export * from "./CloverPaymentSettingsModal.vue?vue&type=script&lang=js"

import "./CloverPaymentSettingsModal.vue?vue&type=style&index=0&id=996c9114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996c9114"]])

export default __exports__